"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeState = exports.serializeEvent = void 0;
const NANOSEC_PER_MILLISEC = 1000000;
function serializeEvent(event, serialize) {
    const copy = { ...event };
    copy.entity = JSON.parse(serialize(copy.entity));
    copy.event_timestamp = copy.event_timestamp
        ? copy.event_timestamp.getTime() * NANOSEC_PER_MILLISEC
        : undefined;
    return JSON.stringify(copy);
}
exports.serializeEvent = serializeEvent;
function serializeState(state, serialize) {
    const copy = { ...state };
    copy.entity = JSON.parse(serialize(copy.entity));
    copy.state_timestamp = copy.state_timestamp
        ? copy.state_timestamp.getTime() * NANOSEC_PER_MILLISEC
        : undefined;
    return JSON.stringify(copy);
}
exports.serializeState = serializeState;
